'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _auth = require('../actions/auth');

var _api = require('../api');

var _firebase = require('../firebase/firebase');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(login),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(logout),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loginRequest),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(logoutRequest);

function login() {
    var _response, result, authUser, userIdToken, response, errorMessage;

    return regeneratorRuntime.wrap(function login$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;

                    if (!(env.SKIP_AUTH === 'true')) {
                        _context.next = 9;
                        break;
                    }

                    _context.next = 4;
                    return (0, _effects.call)(_api.requestUnprotectedRoute, 'post', '/signInLocal');

                case 4:
                    _response = _context.sent;


                    localStorage.setItem('authToken', _response.data.token);

                    _context.next = 8;
                    return (0, _effects.put)(_auth.actionCreators.loginSuccess(_response.data.email));

                case 8:
                    return _context.abrupt('return');

                case 9:
                    _context.next = 11;
                    return (0, _effects.call)(function () {
                        return _firebase.firebase.auth().signInWithPopup(_firebase.googleAuthProvider);
                    });

                case 11:
                    result = _context.sent;
                    _context.next = 14;
                    return (0, _effects.call)(function () {
                        return _firebase.firebase.auth().signInWithCredential(result.credential);
                    });

                case 14:
                    authUser = _context.sent;
                    _context.next = 17;
                    return (0, _effects.call)(function () {
                        return authUser.getIdToken();
                    });

                case 17:
                    userIdToken = _context.sent;
                    _context.next = 20;
                    return (0, _effects.call)(_api.requestUnprotectedRoute, 'post', '/signIn', { idToken: userIdToken });

                case 20:
                    response = _context.sent;


                    localStorage.setItem('authToken', response.data.token);

                    _context.next = 24;
                    return (0, _effects.put)(_auth.actionCreators.loginSuccess(authUser.email));

                case 24:
                    _context.next = 32;
                    break;

                case 26:
                    _context.prev = 26;
                    _context.t0 = _context['catch'](0);
                    errorMessage = void 0;


                    if (_context.t0.code) {
                        if (_context.t0.code !== 'auth/popup-closed-by-user') {
                            errorMessage = _context.t0.message;
                        }
                    } else {
                        errorMessage = _context.t0.response.data.error;
                    }

                    _context.next = 32;
                    return (0, _effects.put)(_auth.actionCreators.loginFailed(errorMessage));

                case 32:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 26]]);
}

function logout() {
    return regeneratorRuntime.wrap(function logout$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;

                    localStorage.removeItem('authToken');

                    _context2.next = 4;
                    return (0, _effects.call)(function () {
                        return _firebase.firebase.auth().signOut();
                    });

                case 4:
                    _context2.next = 6;
                    return (0, _effects.put)(_auth.actionCreators.logoutSuccess());

                case 6:
                    _context2.next = 11;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);

                    console.error(_context2.t0);

                case 11:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function loginRequest() {
    return regeneratorRuntime.wrap(function loginRequest$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.takeLatest)(_auth.actionTypes.LOGIN_REQUEST, login);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function logoutRequest() {
    return regeneratorRuntime.wrap(function logoutRequest$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.next = 2;
                    return (0, _effects.takeLatest)(_auth.actionTypes.LOGOUT_REQUEST, logout);

                case 2:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}

exports.default = [loginRequest, logoutRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/auth.js
// module id = 2138
// module chunks = 0